if (!customElements.get('rc-facet-search')) {
  customElements.define(
    'rc-facet-search',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        const input = this.querySelector('[data-rc-facet-search-input]');
        const clear = this.querySelector('[data-rc-facet-search-clear]');
        const status = this.querySelector('[data-rc-facet-search-status]');
        const list = document.getElementById(this.dataset.target);

        if (!input || !clear || !status || !list) return;

        this.initialized = true;
        const showMore = this.closest('show-more-component');
        const showMoreButton = showMore?.querySelector('[ref="showMoreButton"]');
        const normalize = (value) =>
          value
            .normalize('NFKD')
            .replace(/\p{M}/gu, '')
            .toLocaleLowerCase('sv')
            .replace(/[\s\-_'’]+/g, ' ')
            .trim();

        const getItems = () => [...(document.getElementById(this.dataset.target)?.querySelectorAll('[data-rc-filter-option]') || [])];
        const prepareItem = (item) => {
          if (item.dataset.rcInitiallyHidden === undefined) {
            item.dataset.rcInitiallyHidden = String(item.classList.contains('hidden'));
            item.dataset.rcInitiallyMobileHidden = String(item.classList.contains('mobile:hidden'));
          }
        };

        const update = () => {
          const query = normalize(input.value);
          let visible = 0;

          getItems().forEach((item) => {
            prepareItem(item);
            const matches = normalize(item.dataset.rcFilterOption || item.textContent).includes(query);

            if (query) {
              item.classList.remove('hidden', 'mobile:hidden');
              item.hidden = !matches;
            } else {
              item.hidden = false;
              item.classList.toggle('hidden', item.dataset.rcInitiallyHidden === 'true');
              item.classList.toggle('mobile:hidden', item.dataset.rcInitiallyMobileHidden === 'true');
            }

            if (matches) visible += 1;
          });

          clear.hidden = query.length === 0;
          if (showMoreButton) showMoreButton.hidden = query.length > 0;
          status.textContent = query ? (this.dataset.resultTemplate || '__COUNT__').replace('__COUNT__', String(visible)) : '';
        };

        input.addEventListener('input', update);
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && input.value) {
            input.value = '';
            update();
          }
        });
        clear.addEventListener('click', () => {
          input.value = '';
          update();
          input.focus();
        });
      }
    }
  );
}
